import { Checkbox } from '@mui/joy';
import classNames from 'classnames';
import { useField } from 'formik';

import FormField from '../input/FormField';

type Props = {
  callback?: (value: boolean) => void;
  className?: string;
  disabled?: boolean;
  endAdornment?: React.ReactNode;
  flexGrow?: boolean;
  label: React.ReactNode | ((checked: boolean) => React.ReactNode);
  name: string;
  noMargin?: boolean;
  required?: boolean;
  size?: 'sm' | 'md' | 'lg';
  validateOnChange?: boolean;
};

const FormikCheckbox: React.FC<Props> = ({
  callback,
  className,
  disabled,
  endAdornment,
  flexGrow = true,
  label,
  name,
  noMargin = false,
  required = false,
  size = 'sm',
  validateOnChange = false,
}) => {
  const [_field, meta, helpers] = useField<boolean | null>(name);

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const nextValue = e.target.checked;

    callback?.(nextValue);
    helpers.setTouched(true);
    helpers.setValue(nextValue, validateOnChange);
  };

  const error = meta.touched ? meta.error : undefined;
  const value = meta.value ?? false;

  return (
    <FormField
      className={classNames({ 'flex-1': flexGrow }, className)}
      error={error}
      required={required}
      size={size}
    >
      <div className="flex space-x-2">
        <Checkbox
          checked={value}
          disabled={disabled}
          label={typeof label === 'function' ? label(value) : label}
          name={name}
          onBlur={() => helpers.setTouched(true)}
          onChange={handleChange}
        />
        {!!endAdornment && (
          <div className={noMargin ? 'm-0 flex h-[0px] p-0' : 'flex'}>{endAdornment}</div>
        )}
      </div>
    </FormField>
  );
};

export default FormikCheckbox;
